import React, { useState, useEffect } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import Button from "components/CustomButtons/CustomButton.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomModal from "components/CustomModal/Modal.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { RotatingLines } from "react-loader-spinner";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getMakeById,
  saveMake,
  checkMake,
} from "../Services/MakesModelsService";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function EditMake() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();

  const [form, setForm] = useState({
    name: "",
    year: "",
  });
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [toastMessage, setToastMessage] = useState(false);
  const [typeToast, setTypeToast] = useState("danger");
  const [alertLoading, setAlertLoading] = useState(null);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    let yearsArr = [];
    for (let i = -1; i <= 54; i++) {
      yearsArr.push({
        value: `${currentYear - i}`,
        label: `${currentYear - i}`,
      });
    }
    setYears(yearsArr);

    if (id && parseInt(id) > 0) {
      fetchMake(id);
    }
    // eslint-disable-next-line
  }, [id]);

  const fetchMake = async (makeId) => {
    setLoading(true);
    const result = await dispatch(getMakeById({ id: makeId }));
    if (result.payload && result.payload.data) {
      setForm({
        name: result.payload.data.name || "",
        year: result.payload.data.year || "",
      });
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBack = () => {
    history.push("/admin/makesModels");
  };

  const loadingAlert = () => {
    setAlertLoading(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={<h5 style={{ color: "black" }}>{"Loading"}</h5>}
        allowEscape={false}
        closeOnClickOutside={false}
        showConfirm={false}
        showCancel={false}
      >
        <RotatingLines
          strokeColor="gray"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </SweetAlert>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setToastMessage(false);
    loadingAlert();
    const check = await dispatch(
      checkMake({ name: form.name, year: form.year, id: id || 0 })
    );
    if (!check.payload.exists && check.payload.result) {
      const result = await dispatch(saveMake({ ...form, id: id || 0 }));
      setAlertLoading(null);
      if (result.payload && result.payload.result) {
        setMessageToast("Make saved successfully.");
        setTypeToast("success");
        setModalSuccess(true);
      } else {
        setMessageToast(result.payload.message || "Error saving make.");
        setTypeToast("danger");
        setToastMessage(true);
      }
    } else {
      setAlertLoading(null);
      setMessageToast(check.payload.message || "Make already exists.");
      setTypeToast("danger");
      setToastMessage(true);
    }
  };

  return (
    <GridContainer
      justifyContent="center"
      alignItems="center"
      xs={12}
      sm={12}
      md={8}
      style={{ margin: "auto" }}
    >
      <Card>
        <CardBody>
          {alertLoading}
          <form onSubmit={handleSubmit}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Make Name"
                  inputProps={{
                    name: "name",
                    value: form.name,
                    onChange: handleInputChange,
                    maxLength: 30,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomSelect
                  labelText="Year"
                  menuItems={[{ value: "", label: "-- Select --" }, ...years]}
                  inputProps={{
                    name: "year",
                    value: form.year,
                    onChange: handleInputChange,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer style={{ marginTop: "20px" }}>
              <GridItem xs={0} sm={0} md={2}></GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Button
                  variant="default"
                  type="button"
                  onClick={handleBack}
                  block
                >
                  Back
                </Button>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
                <Button variant="green" type="submit" block>
                  Save
                </Button>
              </GridItem>
              <GridItem xs={0} sm={0} md={2}></GridItem>
            </GridContainer>
          </form>
          <CustomModal
            title="Success"
            isOpen={modalSuccess}
            onClose={() => history.push("/admin/makesModels")}
            privacy={false}
            id={"successModal"}
          >
            <GridContainer>
              <GridItem xs={12}>
                <span>{messageToast}</span>
              </GridItem>
              <GridItem xs={12}>
                <Button
                  variant="green"
                  onClick={() => history.push("/admin/makesModels")}
                  block
                >
                  Ok
                </Button>
              </GridItem>
            </GridContainer>
          </CustomModal>
          <Snackbar
            style={{ zIndex: "3000" }}
            place="center"
            color={typeToast}
            message={messageToast}
            open={toastMessage}
            closeNotification={() => setToastMessage(false)}
            close
          />
        </CardBody>
      </Card>
    </GridContainer>
  );
}
